import React, { useState } from "react";
import { Download, X, FileSpreadsheet, CheckCircle2 } from "lucide-react";

function ReporteEncuestaModalComponents({ openModal, loading, handleCloseModal, dataReporte }) {
    const [downloading, setDownloading] = useState(false);
    const [downloaded, setDownloaded] = useState(false);

    const handleDescargarXlsx = () => {
        if (!dataReporte) return;

        setDownloading(true);

        try {
            const link = document.createElement("a");
            link.href = dataReporte;
            link.setAttribute("download", "reporte_encuesta.xlsx");
            link.setAttribute("target", "_blank");
            link.rel = "noopener noreferrer";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            setDownloaded(true);
            setTimeout(() => setDownloaded(false), 3000);
        } catch (e) {
            console.error("Error al descargar el reporte:", e);
        } finally {
            setDownloading(false);
        }
    };

    const handleClose = () => {
        setDownloaded(false);
        handleCloseModal();
    };

    return (
        <>
            {openModal && (
                <div
                    className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
                    onClick={(e) => e.target === e.currentTarget && handleClose()}
                >
                    <div className="w-full max-w-sm overflow-hidden rounded-2xl bg-white shadow-2xl">

                        {/* Header */}
                        <div className="flex items-center justify-between bg-[#104063] px-6 py-4">
                            <div className="flex items-center gap-2">
                                <FileSpreadsheet size={20} className="text-white/80" />
                                <h2 className="text-sm font-semibold text-white">
                                    Reporte de Encuesta
                                </h2>
                            </div>
                            <button
                                type="button"
                                aria-label="cerrar"
                                onClick={handleClose}
                                className="rounded-lg p-1.5 text-white/70 transition-colors hover:bg-white/10 hover:text-white"
                            >
                                <X size={18} />
                            </button>
                        </div>

                        {/* Body */}
                        <div className="flex flex-col items-center gap-4 px-6 py-8">
                            {/* Icono ilustrativo */}
                            <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-emerald-50 ring-4 ring-emerald-100">
                                <FileSpreadsheet size={40} className="text-emerald-600" />
                            </div>

                            <div className="text-center">
                                <p className="text-sm font-semibold text-gray-800">
                                    Archivo listo para descargar
                                </p>
                                {/* <p className="mt-1 text-xs text-gray-400">
                                    Formato&nbsp;
                                    <span className="font-medium text-emerald-600">.xlsx</span>
                                    &nbsp;· Microsoft Excel
                                </p> */}
                            </div>

                            {/* Indicador de URL disponible */}
                            {dataReporte ? (
                                <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-3 py-1 text-xs font-medium text-emerald-700">
                                    <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                                    Reporte generado correctamente
                                </span>
                            ) : (
                                <span className="inline-flex items-center gap-1.5 rounded-full bg-red-50 px-3 py-1 text-xs font-medium text-red-600">
                                    <span className="h-1.5 w-1.5 rounded-full bg-red-400" />
                                    No hay reporte disponible
                                </span>
                            )}
                        </div>

                        {/* Footer */}
                        <div className="border-t border-gray-100 px-6 py-4 flex flex-col gap-2">
                            <button
                                type="button"
                                onClick={handleDescargarXlsx}
                                disabled={loading || downloading || !dataReporte}
                                className={`flex w-full items-center justify-center gap-2 rounded-xl py-3 text-sm font-semibold text-white transition-all duration-200
                                    ${downloaded
                                        ? "bg-emerald-500 hover:bg-emerald-600"
                                        : "bg-[#104063] hover:bg-[#0d3553]"
                                    }
                                    disabled:cursor-not-allowed disabled:opacity-50`}
                            >
                                {downloading ? (
                                    <>
                                        <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                                        Iniciando descarga...
                                    </>
                                ) : downloaded ? (
                                    <>
                                        <CheckCircle2 size={18} />
                                        ¡Descarga iniciada!
                                    </>
                                ) : (
                                    <>
                                        <Download size={18} />
                                        Descargar
                                    </>
                                )}
                            </button>

                            <button
                                type="button"
                                onClick={handleClose}
                                className="w-full rounded-xl py-2.5 text-sm font-medium text-gray-500 transition-colors hover:bg-gray-50 hover:text-gray-700"
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default ReporteEncuestaModalComponents;
